<template>
  <div class="app-container">
    <!-- 信息展示卡片 -->
    <el-card class="box-card mt10 info-card">
      <div class="info-container">
        <div class="info-item">
        
          <span class="info-label">赠送原因：</span>
          <span class="info-value">{{ rowItem ? rowItem.configName : '' }}</span>
        </div>
        <div class="info-item">
        
          <span class="info-label">key：</span>
          <span class="info-value">{{ rowItem ? rowItem.configKey : '' }}</span>
        </div>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新增</el-button>
          <el-button type="primary" size="mini" @click="handleBack" icon="el-icon-back">返回上一页</el-button>
          <!-- <el-button type="danger" size="mini" @click="handleDeleteBatch" plain>批量删除</el-button> -->
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="标题" prop="title" align="center" />
        <el-table-column label="推送城市账套" prop="sendTo" align="center">
          <template slot-scope="{row}">
            {{row.sendTo === 1 ? '杜一生' : row.sendTo === 2 ? '教育公司' : row.sendTo === 3 ? '城市公司' : row.sendTo === 4 ? '收款银行城市公司' : ''}}
          </template>
        </el-table-column>
        <el-table-column label="推送客户身份" prop="ifLevel" align="center">
          <template slot-scope="{row}">
            {{row.ifLevel === 0 ? '不使用条件' : row.ifLevel === 1 ? '是研修班才推送' : row.ifLevel === 2 ? '不是研修班才推送' : row.ifLevel === 3 ? '是体验班才推送' : row.ifLevel === 4 ? '不是体验班才推送' : ''}}
          </template>
        </el-table-column>
        <el-table-column label="是否区分客户杜一生" prop="ifDys" align="center">
          <template slot-scope="{row}">
            {{row.ifDys === 0 ? '不使用条件' : row.ifDys === 1 ? '是杜一生客户才推送' : row.ifDys === 2 ? '不是杜一生客户才推送' : ''}}
          </template>
        </el-table-column>
        <el-table-column label="AB账双方城市id" prop="ifCityidDengyuCityid" align="center">
          <template slot-scope="{row}">
            {{row.ifCityidDengyuCityid === 0 ? '不使用条件' : row.ifCityidDengyuCityid === 1 ? '等于' : row.ifCityidDengyuCityid === 2 ? '不等于' : ''}}
          </template>
        </el-table-column>
        <el-table-column label="对向流水" prop="ifDysOther" align="center">
          <template slot-scope="{row}">
            {{row.ifDysOther === 0 ? '不使用条件' : row.ifDysOther === 1 ? '是杜一生客户才推送' : row.ifDysOther === 2 ? '不是杜一生客户才推送' : ''}}
          </template>
        </el-table-column>
        <el-table-column label="配置详情" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="showConfigDetail(row)">查看配置</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="160">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row)">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" /> -->
    </el-card>
    <!-- 新建表单 -->
    <giveReason-add ref="giveReasonAdd" @created="doQueryList({})" :rowItem="rowItem" />

    <!-- 配置详情弹窗 -->
    <el-dialog title="配置详情" :visible.sync="configDetailVisible" width="800px">
      
      <el-table :data="configDetailList" border>
        <el-table-column label="配置" type="index" width="60" align="center" />
        <el-table-column label="科目编码" prop="code" align="center" >
          <template slot-scope="{row}">
            {{row.code === '-1' ? '银行科目' : row.code}}
          </template>
        </el-table-column>
        <el-table-column label="被操作的客户" prop="auxType" align="center">
          <template slot-scope="{row}">
            {{row.auxType === 1 ? '被操作的客户' : row.auxType === 2 ? 'ab账对方客户' : row.auxType === 3 ? '城市公司' 
            : row.auxType === 4 ? '教育公司' : row.auxType === 5 ? '杜一生' : row.auxType === 6 ? '后勤部' :
             row.auxType === 7 ? '个人' : row.auxType === 8 ? 'ab账对方城市公司' : row.auxType === 9 ? '收款银行城市公司' : ''}}
          </template>
        </el-table-column>
        <el-table-column label="是否是负数" prop="isFuShu" align="center">
          <template slot-scope="{row}">
            {{row.isFuShu === 1 ? '是' : row.isFuShu === 0 ? '否' : ''}}
          </template>
        </el-table-column>
        <el-table-column label="是否是贷科目" prop="isDai" align="center">
          <template slot-scope="{row}">
            {{row.isDai === 1 ? '是' : row.isDai === 0 ? '否' : ''}}
          </template>
        </el-table-column>
        <el-table-column label="辅助项编码" prop="auxCode" align="center" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import giveReasonAdd from './addConfig'
import sysGiftAccountReasonApi from '@/api/config/sysGiftAccountReason'
import Pagination from '@/components/Pagination'

export default {
  props: ['rowItem'],
  components: {
    Pagination,
    giveReasonAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      configDetailVisible: false,
      configDetailList: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },

  methods: {
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {

      this.listLoading = true
      return sysGiftAccountReasonApi.listReasonPz({ id: this.rowItem.id })
        .then(({ data }) => {
          this.list = data
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 显示配置详情
     */
    showConfigDetail(row) {
      this.configDetailList = []
      const configs = [row.configOne, row.configTwo, row.configThree, row.configFour, row.configFive, row.configSix]
      configs.forEach(config => {
        if (config && Object.keys(config).length > 0) {
          try {
            const parsedConfig = typeof config === 'string' ? JSON.parse(config) : config
            if (parsedConfig && Object.keys(parsedConfig).length > 0) {
              this.configDetailList.push(parsedConfig)
            }
          } catch (e) {
            console.error('解析配置数据失败:', e)
          }
        }
      })
      this.configDetailVisible = true
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysGiftAccountReasonApi.removeReasonPz({ id: row.id }))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysGiftAccountReasonApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.giveReasonAdd.handleCreate(row)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.giveReasonAdd.handleUpdate(row)
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }
}
</script>
